import { render, staticRenderFns } from "./statAppointRenshuDates.vue?vue&type=template&id=71837c91"
import script from "./statAppointRenshuDates.vue?vue&type=script&lang=js"
export * from "./statAppointRenshuDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports